<div class="modal-body d-flex flex-column justify-content-center align-items-center">
  <div class="d-flex flex-row justify-content-around align-items-center header">
    <p>{{ policySelected?.name }}</p>
    <p>{{ appSelected?.packageName }}</p>
    @if (requestParam?.body?.startDate && requestParam?.body?.endDate) {
      <p>
        {{ formatDate(requestParam?.body?.startDate) }} - {{ formatDate(requestParam?.body?.endDate) }}
      </p>
    }
    @if (requestParam?.body?.nbAttestations) {
      <p>{{ requestParam?.body?.nbAttestations }}</p>
    }
  </div>

  @if (!loadingOerror()) {
    <div class="d-flex flex-row align-items-center body">
      <div class="d-flex flex-column dpolicy">
        <h3>
          {{ 'security-policies-form-simulation-with-actual-policy' | translate }}
          {{ getCurrentPolicyActivated()?.name }}
        </h3>
        <table>
          <tbody>
            <tr>
              <td class="d-flex flex-row align-items-center title">
                <div class="d-flex flex-row align-items-center">
                  <img src="assets/images/home/card/Attestations.svg">
                  {{ 'menu-attestations' | translate }}
                </div>
              </td>
              <td class="value">{{ resultSimulation()?.nbAttest }}</td>
            </tr>
            <tr>
              <td class="d-flex flex-row align-items-center title">
                <img src="assets/images/home/card/Compromise Reports.png">
                {{ 'menu-compromise-reports' | translate }}
              </td>
              <td class="value">{{ resultSimulation()?.nbCompro }}</td>
            </tr>
          </tbody>
        </table>
        <h4>
          {{ calcPourcentage(resultSimulation()?.nbCompro, resultSimulation()?.nbAttest) | percent:'1.2-2' }}
          {{ 'security-policies-form-simulation-percentage' | translate }}
        </h4>
        <h4 class="triggered">{{ 'security-policies-form-simulation-triggered' | translate }}</h4>

        <!-- Bloc avec popover/détails pour Detectors viewer -->
        <div class="d-flex flex-wrap justify-content-around cards" *kaHasRoles="['bo-dip-technical-detectors-viewer']; checkRealm: true; else noDetectorsViewer">
          @for (elem of lactualDetect(); track elem) {
            <div type="button" class="d-flex flex-column justify-content-center align-items-center family">
              @if (elem.family != 'black&White') {
                <img [ngbPopover]="pophover"
                  id="probe-{{elem.family.toLowerCase()}}"
                  [ngClass]="{ 'icongreen': elem.counter == 0, 'iconred': elem.counter > 0 }"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.svg" alt="">
              } @else {
                <img [ngbPopover]="pophover"
                  id="probe-{{elem.family.toLowerCase()}}"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.png" alt="">
              }
              <div class="text-capitalize text-center"
                [ngClass]="{ 'succes': elem.counter == 0, 'danger': elem.counter > 0 }">
                {{ elem.family.toLowerCase() }}
              </div>
              <ng-template #pophover>
                @if (elem?.detectors) {
                  <div class="d-flex flex-column detectAdmin">
                    <table>
                      <thead>
                        <tr>
                          <td>Technical Id</td>
                          <td>{{ 'name' | translate }}</td>
                          <td>Nb compro</td>
                        </tr>
                      </thead>
                      <tbody>
                        @for (detect of elem?.detectors; track detect) {
                          <tr>
                            <td><h6>0x{{ detect?.detector?.technicalId }}</h6></td>
                            <td><h6 class="text-capitalize">{{ detect?.detector?.name }}</h6></td>
                            <td class="number"><h6 class="text-capitalize">{{ detect?.occurrence }}</h6></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </ng-template>
            </div>
          }
        </div>

        <ng-template #noDetectorsViewer>
          @for (elem of lactualDetect(); track elem) {
            <div class="d-flex flex-column justify-content-center align-items-center family">
              @if (elem.family != 'black&White') {
                <img id="probe-{{elem.family.toLowerCase()}}"
                  [ngClass]="{ 'icongreen': elem.counter == 0, 'iconred': elem.counter > 0 }"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.svg" alt="">
              } @else {
                <img id="probe-{{elem.family.toLowerCase()}}"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.png" alt="">
              }
              <div class="text-capitalize text-center"
                [ngClass]="{ 'succes': elem.counter == 0, 'danger': elem.counter > 0 }">
                {{ elem.family.toLowerCase() }}
              </div>
            </div>
          }
        </ng-template>
      </div>
      <hr class="separation">
      <div class="d-flex flex-column justify-content-center align-items-center dpolicy">
        <h3>
          {{ 'security-policies-form-simulation-with-selected-policy' | translate }}
          {{ policySelected?.name }}
        </h3>
        <table>
          <tbody>
            <tr>
              <td class="title">
                <div class="d-flex flex-row align-items-center">
                  <img src="assets/images/home/card/Attestations.svg">
                  {{ 'menu-attestations' | translate }}
                </div>
              </td>
              <td class="value {{ setClass(resultSimulation()?.nbAttest, resultSimulation()?.nbAttestSimulated) }}">
                {{ resultSimulation()?.nbAttestSimulated }}
              </td>
            </tr>
            <tr>
              <td class="d-flex flex-row align-items-center title">
                <img src="assets/images/home/card/Compromise Reports.png">
                {{ 'menu-compromise-reports' | translate }}
              </td>
              <td class="value {{ setClass(resultSimulation()?.nbComproSimulated, resultSimulation()?.nbCompro) }}">
                {{ resultSimulation()?.nbComproSimulated }}
              </td>
            </tr>
          </tbody>
        </table>
        <h4>
          <b class="{{ setClass(
            calcPourcentage(resultSimulation()?.nbComproSimulated, resultSimulation()?.nbAttestSimulated),
            calcPourcentage(resultSimulation()?.nbCompro, resultSimulation()?.nbAttest)
          ) }}">
            {{ calcPourcentage(resultSimulation()?.nbComproSimulated, resultSimulation()?.nbAttestSimulated) | percent:'1.2-2' }}
          </b>
          {{ 'security-policies-form-simulation-percentage' | translate }}
        </h4>
        <h4 class="triggered">{{ 'security-policies-form-simulation-triggered' | translate }}</h4>
        @if (getRoleDetectorViewer()) {
          <div class="d-flex flex-wrap justify-content-around cards" >
            @for (elem of lnewDetect(); track elem) {
              <div type="button" class="d-flex flex-column justify-content-center align-items-center family">
                @if (elem.family != 'black&White') {
                  <img [ngbPopover]="pophover"
                  id="probe-{{elem.family.toLowerCase()}}"
                  [ngClass]="{ 'icongreen': elem.counter == 0, 'iconred': elem.counter > 0 }"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.svg" alt="">
              } @else {
                <img [ngbPopover]="pophover"
                  id="probe-{{elem.family.toLowerCase()}}"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.png" alt="">
              }
              <div class="text-capitalize text-center"
                [ngClass]="{ 'succes': elem.counter == 0, 'danger': elem.counter > 0 }">
                {{ elem.family.toLowerCase() }}
              </div>
              <ng-template #pophover>
                @if (elem?.detectors) {
                  <div class="d-flex flex-column detectAdmin">
                    <table>
                      <thead>
                        <tr>
                          <td>Technical Id</td>
                          <td>{{ 'name' | translate }}</td>
                          <td>Nb compro</td>
                        </tr>
                      </thead>
                      <tbody>
                        @for (detect of elem?.detectors; track detect) {
                          <tr>
                            <td><h6>0x{{ detect?.detector?.technicalId }}</h6></td>
                            <td><h6 class="text-capitalize">{{ detect?.detector?.name }}</h6></td>
                            <td class="number"><h6 class="text-capitalize">{{ detect?.occurrence }}</h6></td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </ng-template>
            </div>
          }
        </div>
      } @else {
          @for (elem of lnewDetect(); track elem) {
            <div class="d-flex flex-column justify-content-center align-items-center family">
              @if (elem.family != 'black&White') {
                <img id="probe-{{elem.family.toLowerCase()}}"
                  [ngClass]="{ 'icongreen': elem.counter == 0, 'iconred': elem.counter > 0 }"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.svg" alt="">
              } @else {
                <img id="probe-{{elem.family.toLowerCase()}}"
                  src="assets/icons/probesFamilies/{{elem.family.toLowerCase()}}.png" alt="">
              }
              <div class="text-capitalize text-center"
                [ngClass]="{ 'succes': elem.counter == 0, 'danger': elem.counter > 0 }">
                {{ elem.family.toLowerCase() }}
              </div>
            </div>
          }
        }
      </div>
      
    </div>
  } @else {
    <app-loading-error [boolean]="true" [message]="'waiting-for-simulation' | translate"></app-loading-error>
  }
</div>
<app-toast-component></app-toast-component>
